import {link} from "@/class/link";
import store from "@/store/store";
import {PK} from "@/class/data-type";
import {baseModelLink} from "@/class/baseModel";
import chapter from "@/class/interactive-image/chapter";

export class label extends baseModelLink {
    
    parentObjectType = "";
    
    _chapterId = new PK("chapterId");
    
    _default = {
        "coords" : [
            {name:"x_coord", type:Number, default:0.0},
            {name:"y_coord", type: Number, default: 0.0},
        ],
        "pointer": [
            {name:"pointer_x_coord", type:Number, default:0.0},
            {name:"pointer_y_coord", type: Number, default: 0.0},
        ],
        "order": [
            {name: "order", type: Number, default: 0},
        ]
    }
    
    deleted = false;
    /**
     * Variable de fonctionnement
     */
    isEditing = false;
    isHovered = false;
    isSelected = false;
    isDrawing = false;
    
    label_color = "#ffffff";
    background_color = "#ffffff";
    
    init(){
        this.data.push(...this._default.order)
        super.init();
    }
    
    setGlobalInfo(){
        this._globaInfo = store.getters.label(this.parentObjectType, this.getObjectType())
    }
    
    setDataReq(data, chapterId, storyId){
        
        if(chapterId && storyId) {
            this._chapterId.set(chapterId);
            this._story.set(storyId);
        }
        
        super.setDataReq(data);
    
        return this;
    }
    
    getDataReq(){
        
        let data = super.getDataReq();
        
        data["chapter"] = this._chapterId.get();
        
        return data;
    }
    getDeleteReq() {
        return {
            chapter : this._chapterId.get()
        }
    }
    
    getImage(){
        if(!this.image) return store.getters.getDefault("BaseImage");
        return this.image.media || store.getters.getDefault("BaseImage");
    }
    
    getDataClone(){
        return this._data;
    }
    
    hasImage(){
        return typeof this.image !== "undefined" && this.image.media !== "";
    }
    
    toReq(){
        
        let data = super.toReq()
        
        data["chapter"] = this._chapterId.get();
    
        return data;
    }
    
    /**
     * Fucntions de fonctionnement
     */
    
    enter(){
        this.isHovered = true;
    }
    leave(){
        this.isHovered = false;
    }
    select(){
        this.isSelected = true;
    }
    unselect(){
        this.isSelected = false;
    }
    edit(){
        this.isEditing = true;
    }
    unedit(){
        this.isEditing = false;
        this.isDrawing = false
    }
    remove(){
        this.delete();
        this.deleted = true;
    }
    draw(){
        this.isDrawing = true
    }
    undraw(){
        this.isDrawing = false
    }
    isDeleted(){
        return this.deleted
    }
}